// extracted by mini-css-extract-plugin
export default {"Form":"SendPredefinedSms_Form__G66uj","FlexRow":"SendPredefinedSms_FlexRow__gfMcg","MessageTextareaContainer":"SendPredefinedSms_MessageTextareaContainer__SL6Yq"};